import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setDevice } from "../redux/slices/deviceSlice";
import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { setEmmsHeaders } from "../redux/slices/emmsAuthSlice";
import { setMeetingSpaces } from "../redux/slices/allMeetingSpacesSlice";

import { setCurrentEmms } from "../redux/slices/currentEmmsSlice";
import { useEffect } from "react";
import { setStagedDevice } from "../redux/slices/stagedDeviceSlice";
import { toast } from "react-toastify";
import { DataGrid } from "@mui/x-data-grid";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  paddingTop: 1,
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 300,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldContainer: {
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
    paddingTop: "1rem",
  },

  submitButton: {
    textTransform: "none",
    marginLeft: "70%",
  },
  label: {
    fontWeight: "bold",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "4%",
  },
}));
function BulkAcceptandLinkModal({ selectedIds, setSelectedIds }) {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();
  const api = localStorage.getItem("api");
  const meetingData = useSelector((state) => state.allmeetingspaces);
  const meetingLinkOptions = meetingData.allmeetingspaces;
  const emmsheaders = useSelector((state) => state.emmsheader);
  const emmsList = useSelector((state) => state.emms);
  const emmsOptions = emmsList.emms;
  const [selectedOption, setSelectedOption] = useState(null);
  const curremms = useSelector((state) => state.curremms);

  const deviceData = useSelector((state) => state.device);
  const devices = deviceData?.device;
  const [tableData, setTableData] = useState([]);
  const [requestData, setRequestData] = useState({
    id: selectedIds,
    meetinglinkid: "",
    linktype: "",
    emms: "",
  });
  const columns = [
    { field: "id", headerName: "Serial", flex: 1 },
    { field: "ipAddress", headerName: "IP", flex: 1 },
    { field: "portNumber", headerName: "Port", flex: 1 },
    { field: "type", headerName: "Type", flex: 1 },
  ];

  const headers = useSelector((state) => state.header);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setRequestData({
      meetinglinkid: "",
      linktype: "",
      emms: "",
    });
  };
  const stageddevicedata = useSelector((state) => state.stagedDevice);
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    const filteredDevices = stageddevicedata?.stagedDevice?.filter((device) =>
      selectedIds?.includes(device.id)
    );
    setTableData(filteredDevices);
  }, [stageddevicedata.stagedDevice, selectedIds]);

  const handleBulkLink = () => {
    setIsModalOpen(true);
    if (selectedIds?.length === 0) {
      setTableData([]);
    } else {
      const requestBody = selectedIds?.map((id) => ({
        id,
        meetinglinkid: requestData.meetinglinkid,
      }));
      setTableData(requestData);

      axios
        .post(api + "/device/stage/accept", requestBody, headers)
        .then((response) => {
          const currentDevices = devices;
          const updatedDevice = [...currentDevices];
          response.data.forEach((newRecord) => {
            const existingRecordIndex = updatedDevice.findIndex(
              (record) => record.id === newRecord.id
            );
            if (existingRecordIndex !== -1) {
              updatedDevice[existingRecordIndex] = newRecord;
            } else {
              updatedDevice.push(newRecord);
            }
          });
          dispatch(setDevice(updatedDevice));
          toast.success("Linked successfully", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });

          handleBulkOperation();
          setSelectedIds(null);
        })
        .catch((error) => {
          console.error(error);
          toast.error("Error while linking", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          setSelectedIds(null);
        });
    }
    handleClose();
  };
  useEffect(() => {
    const initialValue = curremms?.curremm?.id;

    setSelectedOption(initialValue);
    handleMeetingData();
  }, [selectedOption, selectedIds]);

  const handleMeetingData = () => {
    const requestBody = {
      path: "meetingspace",
      query: {},
      emmsId: `${selectedOption}`,
      body: {},
      requestType: "GET",
      headers: emmsheaders?.emmsheaders?.headers,
    };

    axios
      .post(api + `/emms/piggyback`, requestBody, headers)
      .then((response) => {
        dispatch(setMeetingSpaces(response.data));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRequestData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === "emms") {
      setSelectedOption(value);
    }
    let selectedEmms = emmsList?.emms?.find((element) => element.id === value);

    if (selectedEmms !== null) {
      const apiId = selectedEmms?.apiId;
      const apiKey = selectedEmms?.apiKey;
      dispatch(setCurrentEmms(selectedEmms));

      const emmsheaders = {
        headers: {
          "Content-Type": "application/json",
          "x-api-id": apiId,
          "x-api-key": apiKey,
        },
      };

      dispatch(setEmmsHeaders(emmsheaders));
      handleMeetingData();
    }
  };
  const handleBulkOperation = () => {
    axios
      .get(api + "/device/stage", headers)
      .then((response) => {
        dispatch(setStagedDevice(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };
  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="outlined"
        onClick={handleOpen}
        disabled={selectedIds === null || selectedIds?.length === 0}
      >
        Accept & Link Selected
      </Button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <h4 style={{ fontWeight: "100" }}>
              Accepting and linking multiple Elhis to Meeting Room{" "}
            </h4>
          </div>
          <br />
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleBulkLink}
          >
            <div>
              <div>
                <div>
                  {getLabelWithAsterisk("Devices Info:", true)}
                  {tableData?.length > 0 && (
                    <DataGrid
                      rows={tableData}
                      columns={columns}
                      initialState={{
                        pagination: {
                          paginationModel: {
                            pageSize: 3,
                          },
                        },
                      }}
                      pageSizeOptions={[3]}
                    />
                  )}
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Link Type:", true)}
                  <FormControl style={{ width: "28.5ch" }} size="small">
                    {requestData.linktype ? null : (
                      <InputLabel id="linktype-label">Link Type</InputLabel>
                    )}

                    <Select
                      labelId="linktype-label"
                      id="linktype"
                      name="linktype"
                      value={requestData.linktype}
                      onChange={handleChange}
                    >
                      <MenuItem value="MeetingRoom">Meeting Room</MenuItem>
                    </Select>
                  </FormControl>
                </div>

                <div className={classes.fieldContainer}>
                  {requestData.linktype === "MeetingRoom" && (
                    <>
                      {getLabelWithAsterisk("EMMS Service:", true)}
                      <FormControl
                        style={{ width: "28.5ch" }}
                        size="small"
                        fullWidth
                      >
                        {requestData.emms ? null : (
                          <InputLabel id="service-label">
                            EMMS Service
                          </InputLabel>
                        )}

                        <Select
                          labelId="service-label"
                          id="emms"
                          name="emms"
                          value={requestData.emms}
                          onChange={handleChange}
                        >
                          {emmsOptions?.map((emms) => (
                            <MenuItem key={emms.id} value={emms.id}>
                              {emms.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div>
                        {" "}
                        <div className={classes.fieldContainer}>
                          {getLabelWithAsterisk("Meeting Link ID:", true)}
                          <FormControl
                            style={{ width: "28.5ch" }}
                            size="small"
                            fullWidth
                          >
                            {requestData.meetinglinkid ? null : (
                              <InputLabel>Meeting Link ID</InputLabel>
                            )}

                            <Select
                              name="meetinglinkid"
                              value={requestData.meetinglinkid}
                              onChange={handleChange}
                            >
                              {meetingLinkOptions?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                  {option.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className={classes.buttonContainer}>
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="error"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                onClick={handleBulkLink}
                color="primary"
              >
                Link
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default BulkAcceptandLinkModal;
